
// Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Sauvegarde hybride : localStorage immédiat + session serveur pour persistance cross-device
export async function saveSessionData(key, data) {
  if (key !== 'token' && key !== 'authToken') {
    try {
      // 1. Sauvegarde locale immédiate (performance)
      localStorage.setItem(key, JSON.stringify(data));
      
      // 2. Sauvegarde session serveur (persistance cross-device)
      const response = await fetch(`${API_BASE_URL}/api/session-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Important pour les cookies de session
        body: JSON.stringify({ key, data })
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (response.status === 401 && errorData.code === 'AUTH_REQUIRED') {
          console.warn(`🔐 ${key} non sauvegardé: utilisateur non authentifié`);
        } else {
          throw new Error(`Erreur ${response.status}: ${errorData.error || 'Erreur serveur'}`);
        }
      } else {
        console.log(`✅ ${key} sauvegardé en local ET session serveur`);
      }
    } catch (error) {
      console.warn(`❌ Erreur sauvegarde session ${key}, local seulement:`, error.message);
      // Le localStorage est déjà fait, donc pas de perte de données
    }
  }
}

// Chargement intelligent : session serveur d'abord, fallback localStorage
export async function loadSessionData(key) {
  if (key !== 'token' && key !== 'authToken') {
    try {
      // 1. Essayer la session serveur d'abord (source de vérité cross-device)
      const response = await fetch(`${API_BASE_URL}/api/session-data/${key}`, {
        method: 'GET',
        credentials: 'include',
      });
      
      if (response.ok) {
        const sessionData = await response.json();
        if (sessionData !== null && sessionData !== undefined) {
          // Synchroniser le localStorage avec la session
          localStorage.setItem(key, JSON.stringify(sessionData));
          console.log(`✅ ${key} chargé depuis session serveur + sync local`);
          return sessionData;
        }
      } else if (response.status === 401) {
        console.warn(`🔐 ${key} non chargé: utilisateur non authentifié, utilisation localStorage`);
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.warn(`❌ Erreur session ${response.status}: ${errorData.error}, fallback local`);
      }
    } catch (error) {
      console.warn(`❌ Erreur chargement session ${key}, fallback local:`, error.message);
    }
    
    // 2. Fallback sur localStorage si session indisponible
    const local = localStorage.getItem(key);
    if (local) {
      try {
        const localData = JSON.parse(local);
        console.log(`📱 ${key} chargé depuis localStorage`);
        
        // Essayer de pousser vers session pour sync future (sans attendre)
        try {
          await saveSessionData(key, localData);
        } catch (e) {
          // Ignorer les erreurs de sync silencieusement
        }
        
        return localData;
      } catch (e) {
        return local;
      }
    }
  }
  return null;
}